import { render, staticRenderFns } from "./digital-twin-main.component.vue?vue&type=template&id=bda7fa0e&scoped=true"
import script from "./digital-twin-main.component.ts?vue&type=script&lang=ts&external"
export * from "./digital-twin-main.component.ts?vue&type=script&lang=ts&external"
import style0 from "./digital-twin-main.component.vue?vue&type=style&index=0&id=bda7fa0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda7fa0e",
  null
  
)

export default component.exports